import React from "react";
import DegreeUniversityAssigningInsp from "./DegreeUniversityAssigningInsp";
import UniversityAssigningInsp from "./UniversityAssigningInsp";
import { useLocation } from "react-router-dom";
export default function UniversityAssigningInspection() {
  const userid = sessionStorage.getItem("user_id");
  const location = useLocation();

  const serviceType = location.state?.serviceType || "eop";
  return <>
    {userid === "jd_admin" || userid === "section_admin" ? <DegreeUniversityAssigningInsp serviceType={serviceType} /> : <UniversityAssigningInsp serviceType={serviceType} />}</>;
}
